export const Wifi = ({
  width = '20',
  height = '20',
}: {
  width?: string;
  height?: string;
  fill?: string;
  backgroundFill?: string | null;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 16.668H10.0083"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.66602 7.35102C3.95778 5.30121 6.92463 4.16797 9.99935 4.16797C13.0741 4.16797 16.0409 5.30121 18.3327 7.35102"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.16602 10.7142C5.72376 9.18728 7.81808 8.33203 9.99935 8.33203C12.1806 8.33203 14.2749 9.18728 15.8327 10.7142"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.08398 13.6911C7.86285 12.9276 8.91001 12.5 10.0007 12.5C11.0913 12.5 12.1384 12.9276 12.9173 13.6911"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
